var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default",function(){return [(!_vm.ignoreDay)?[_vm._v(_vm._s(_vm.day)+":")]:_vm._e(),_vm._v(_vm._s(_vm.hour)+":"+_vm._s(_vm.minute)+":"+_vm._s(_vm.second)+"\n\t")]},{"day":_vm.day,"hour":_vm.hour,"minute":_vm.minute,"second":_vm.second})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }